import React from 'react'
import { Icon } from 'components/common/Icon'
import { InfoDot } from 'components/common/InfoDot'
import cx from 'classnames'

const infoDotThemes = {
  blue: {
    default: 'bg-secondary-default',
    dark: 'bg-secondary-dark',
  },
  purple: {
    default: 'bg-primary-default',
    dark: 'bg-primary-dark',
  },
}

type InfoDotTheme = keyof typeof infoDotThemes

export type StepProps = {
  id: number
  title: string
  description: React.ReactNode
  iconName?: string
  iconCustom?: boolean
  iconFilled?: boolean
  iconSize?: number
  iconSizeMobile?: number
  iconClassName?: string
  className?: string
  titleClassName?: string
  infoDotTheme?: InfoDotTheme
  dark?: boolean
}

export const Step = ({
  id,
  title,
  description,
  iconName,
  iconCustom,
  iconFilled,
  iconSize,
  iconSizeMobile,
  iconClassName,
  className,
  titleClassName,
  dark,
  infoDotTheme = 'blue',
}: StepProps) => {
  return (
    <li className={`flex items-start space-x-3 ${className}`}>
      <InfoDot
        className={cx(`${infoDotThemes[infoDotTheme].default} text-cool-150`, {
          [infoDotThemes[infoDotTheme].dark]: dark === true,
        })}
      >
        {id}
      </InfoDot>
      {iconName && (
        <>
          <Icon
            name={iconName}
            custom={iconCustom}
            filled={iconFilled}
            size={iconSizeMobile}
            className={`lg:hidden [@media(max-width:349px)]:hidden ${iconClassName}`}
          />
          <Icon
            name={iconName}
            custom={iconCustom}
            filled={iconFilled}
            size={iconSize}
            className={`hidden lg:block ${iconClassName}`}
          />
        </>
      )}
      <div>
        <p
          className={`text-base font-medium text-cool-1000 lg:text-lg ${titleClassName}`}
        >
          {title}
        </p>
        <div className='whitespace-pre-wrap text-sm text-cool-600'>
          {description}
        </div>
      </div>
    </li>
  )
}
